module.exports = __webpack_public_path__ + "img/music-file.12169f0f.svg";